import React, {useImperativeHandle, useLayoutEffect, useReducer, useRef} from "react";
import {UserHomepageControllerContext, UserHomepageStateContext} from "../../../index";
import Controller from "../../../core/controller";
import UserHomepageReducer from "../../../core/reducer";

const _UserHomepageStateController = ({children, data = undefined, viewMode}, ref) => {
    const reducerRef = useRef(new UserHomepageReducer());
    const [state, reducer] = useReducer(
        reducerRef.current.reducer,
        {
            controlPanelCollapsed: false,
            viewMode: viewMode,
            data: data,
        },
        reducerRef.current.initializer
    );
    const controllerRef = useRef(new Controller(reducer));

    /**
     * With each change in the state:
     * - dispatches the queued events of the controller.
     */
    useLayoutEffect(() => {
        controllerRef.current.state = state;
    }, [state])

    /**
     * With each change in the view-mode of the props:
     * - syncs the controllers' view mode with the view mode of the props.
     */
    useLayoutEffect(() => {
        controllerRef.current.changeViewMode(viewMode);
    }, [viewMode])

    /**
     * Binds the passed ref from the parent with the dispatcher of this component.
     */
    useImperativeHandle(ref, () => ({
        /**
         * @return {UserHomepageController}
         */
        get controller() {
            return controllerRef.current;
        },
        /**
         * @return {UserHomepageState}
         */
        get state() {
            return state;
        }
    }), [controllerRef, state])


    return (
        <>
            <UserHomepageControllerContext.Provider value={controllerRef.current}>
                <UserHomepageStateContext.Provider value={state}>
                    {children}
                </UserHomepageStateContext.Provider>
            </UserHomepageControllerContext.Provider>
        </>
    )
}


export default _UserHomepageStateController;
